module.exports = __webpack_public_path__ + "static/poligono_13_03-4fced2fbb2b4315aabb50546c9ebae6d.jpg";